export default __webpack_public_path__ + "static/media/pantry2-after1-768w.2964e9df.avif";